import Vue from 'vue';
import moment from 'moment';
import { farey } from './utilities';

Vue.filter('date-format', (value, which) => {
  let format;

  switch (which) {
    case 'time':
      format = 'h:mm A';
      break;
    case 'date':
      format = 'dddd, MMM D';
      break;
    case 'long':
    default:
      format = 'dddd, MMM Do YYYY, h:mm A';
  }

  return moment.utc(value).local().format(format);
});

Vue.filter('phone', value => {
  if (value.length < 8) {
    return value.replace(/(\d{3})(\d{4})/, '$1 - $2');
  }

  return value.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 - $3');
});

Vue.filter('fractional', weight => {
  const parts = [];
  const mass = parseFloat(weight);

  parts.push(Math.floor(mass));

  if (mass % 1 > 0) {
    parts.push(farey(mass % 1, 10).join('/'));
  }

  return parts.filter(n => n !== 0).join(' ');
});

Vue.filter('unit-of-measure', (value, count = 1, abbreviate = false) => {
  switch (value) {
    case 'lb':
    case 'lbs':
    case 'pound':
    case 'pounds':
      if (count % 1 === 0 && Math.trunc(count) === 1) {
        return abbreviate ? 'lb' : 'pound';
      }

      return abbreviate ? 'lbs' : 'pounds';
    case 'dry oz':
    case 'dry ounce':
    case 'oz':
      if (abbreviate) {
        return 'dry oz';
      }

      return [
        'dry ounce',
        count % 1 === 0 && Math.trunc(count) === 1 ? 's' : '',
      ].join('');
    case 'ea':
    case 'each':
    default:
      return 'each';
  }
});

Vue.filter('money', value => Vue.filter('currency')(value / 100));



// WEBPACK FOOTER //
// ./src/plugins.js